// eslint-disable-next-line @typescript-eslint/no-redeclare
export var IntlMessageFormat;
(function (_IntlMessageFormat) {
  var Type = /*#__PURE__*/function (Type) {
    Type[Type["LITERAL"] = 0] = "LITERAL";
    Type[Type["ARGUMENT"] = 1] = "ARGUMENT";
    Type[Type["PLURAL"] = 6] = "PLURAL";
    Type[Type["POUND"] = 7] = "POUND";
    return Type;
  }({});
  _IntlMessageFormat.Type = Type;
})(IntlMessageFormat || (IntlMessageFormat = {}));